import { render, staticRenderFns } from "./MyProfileView.vue?vue&type=template&id=5820c008&scoped=true&"
import script from "./MyProfileView.vue?vue&type=script&lang=js&"
export * from "./MyProfileView.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileView.vue?vue&type=style&index=0&id=5820c008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820c008",
  null
  
)

export default component.exports